export const LUONG_CUNG = 1;
export const LUONG_MEM = 2;
export const LUONG_CUNG_THEO_BAC = 3;
export const LUONG_CUNG_CO_DINH = 4;
export const LUONG_CUNG_PARTTIME = 5;

export const mechanisms = [
    {
        id: 2,
        name: 'Lương mềm'
    },
    {
        id: 3,
        name: 'Lương cứng theo bậc'
    },
    {
        id: 4,
        name: 'Lương cứng cố định'
    },
    {
        id: 5,
        name: 'Lương cứng partime'
    }
];


export const mechanisms2 = [
    {
        id: 1,
        name: 'Lương cứng'
    },
    {
        id: 2,
        name: 'Lương mềm'
    },
];

export const  part_time_fixed_salary = [
    {
        id: 5,
        name: 'Lương cứng partime'
    },
    {
        id: 2,
        name: 'Lương mềm'
    },
];

export const  full_time_fixed_salary = [
    {
        id: 3,
        name: 'Lương cứng theo bậc'
    },
    {
        id: 4,
        name: 'Lương cứng cố định'
    },
    {
        id: 2,
        name: 'Lương mềm'
    },
];

export const mechanismFull = [
    {
        id: 1,
        name: 'Lương cứng'
    },
    {
        id: 2,
        name: 'Lương mềm'
    },
    {
        id: 3,
        name: 'Lương cứng theo bậc'
    },
    {
        id: 4,
        name: 'Lương cứng cố định'
    },
    {
        id: 5,
        name: 'Lương cứng partime'
    }
];

// Cơ chế lương khu vực cũ (HN-HCM - Phong Châu)
// Áp dụng cho: MB01 (16), MB03 (17), MB04 (19), MT02 (13)
export const oldAreaSalesMechanism = [
    {
        id: 2,
        name: 'Lương mềm'
    },
    {
        id: 5,
        name: 'Lương cứng partime'
    },
    {
        id: 1,
        name: 'Lương cứng'
    }
];

export const oldAreaCollaboratorMechanism = [
    {
        id: 1,
        name: 'Lương cứng'
    },
    {
        id: 2,
        name: 'Lương mềm'
    }
];

// Cơ chế lương khu vực mới (Đà Nẵng, ...)
// Áp dụng cho: MB02, MB05 (21), MT01 (9), MT02 (13)
export const newAreaSalesMechanism = [
    {
        id: 2,
        name: 'Lương mềm (tỉnh)'
    },
    {
        id: 5,
        name: 'Lương cứng partime'
    },
    {
        id: 3,
        name: 'Lương cứng theo bậc'
    },
    {
        id: 4,
        name: 'Lương cứng cố định'
    }
];

export const newAreaCollaboratorMechanism = [
    {
        id: 1,
        name: 'Lương cứng'
    },
    {
        id: 2,
        name: 'Lương mềm'
    }
];

// Danh sách khu vực áp dụng cơ chế cũ (Phong Châu)
export const oldAreaIds = [16, 17, 19, 13];

// Danh sách khu vực áp dụng cơ chế mới (Đà Nẵng, ...)
export const newAreaIds = [21, 9, 13];






/* =============================================================
 * LUỒNG MỚI: cơ chế lương theo cơ sở trả lương (profile.facility)
 *
 * profile.facility:
 *   1 = HN - HCM
 *   2 = Cơ chế lương tỉnh mới (MB02 - 22, MB05 - 21, MT01 - 9, MT02 Đà Nẵng - 13)
 *   3 = Cơ chế lương tỉnh cũ  (MB01 - 16, MB03 - 17, MB04 - 19, MT02 Phong Châu - 13)
 *
 * Chỉ phân biệt cơ chế lương Fulltime theo khu vực.
 * Parttime và Cộng tác viên dùng chung cơ chế trên toàn công ty.
 *
 * Khi profile.facility rỗng => trả về null để màn hình giữ nguyên luồng cũ.
 * ============================================================= */

export const FACILITY_HN_HCM = 1;
export const FACILITY_TINH_MOI = 2;
export const FACILITY_TINH_CU = 3;

// account_type.id - khai báo tại chỗ để tránh circular import với accountTypeOption.js
// Sales: 1 = Sale Leader, 2 = Sale Expert, 3 = Sale, 4 = Sale Intern
const ACCOUNT_TYPE_SALES = [1, 2, 3, 4, 29];
const ACCOUNT_TYPE_GDVP = 5;

const OPTION_LUONG_CUNG = {id: LUONG_CUNG, name: 'Lương cứng'};
const OPTION_LUONG_MEM = {id: LUONG_MEM, name: 'Lương mềm'};
const OPTION_LUONG_MEM_TINH = {id: LUONG_MEM, name: 'Lương mềm (tỉnh)'};
const OPTION_LUONG_CUNG_PARTTIME = {id: LUONG_CUNG_PARTTIME, name: 'Lương cứng partime'};
const OPTION_LUONG_CUNG_THEO_BAC = {id: LUONG_CUNG_THEO_BAC, name: 'Lương cứng theo bậc'};
const OPTION_LUONG_CUNG_CO_DINH = {id: LUONG_CUNG_CO_DINH, name: 'Lương cứng cố định'};

// Sales (account_type.id thuộc [1, 2, 3, 4])
export const facilitySalesMechanism = {
    [FACILITY_HN_HCM]: [
        OPTION_LUONG_MEM,
        OPTION_LUONG_CUNG_PARTTIME,
        OPTION_LUONG_CUNG
    ],
    [FACILITY_TINH_CU]: [
        OPTION_LUONG_MEM_TINH,
        OPTION_LUONG_CUNG_PARTTIME,
        OPTION_LUONG_CUNG_THEO_BAC,
        OPTION_LUONG_CUNG_CO_DINH
    ],
    [FACILITY_TINH_MOI]: [
        OPTION_LUONG_MEM_TINH,
        OPTION_LUONG_CUNG_PARTTIME,
        OPTION_LUONG_CUNG
    ]
};

// Khu vực (khuvuc_id) áp dụng cho từng cơ chế lương tỉnh.
// HN - HCM và GĐVP không giới hạn khu vực nên không khai báo ở đây.
export const facilityAreaIds = {
    // MB01 (16), MB03 (17), MB04 (19), MT02 - Phong Châu (13)
    [FACILITY_TINH_CU]: [16, 17, 19, 13],
    // MB02 (22), MB05 (21), MT01 (9), MT02 - Đà Nẵng (13)
    [FACILITY_TINH_MOI]: [22, 21, 9, 13]
};

// Cộng tác viên (is_collaborators = 1) - dùng chung toàn công ty, không phụ thuộc khu vực
export const facilityCollaboratorMechanism = [
    OPTION_LUONG_CUNG,
    OPTION_LUONG_MEM
];

// GĐVP - áp dụng cho tất cả khu vực (SL đã nằm trong nhóm Sales ở trên)
export const facilityManagerMechanism = [
    OPTION_LUONG_MEM,
    OPTION_LUONG_CUNG
];

/**
 * Lấy danh sách cơ chế lương theo luồng mới (profile.facility).
 *
 * @param {Object} profile - profile của user (chấp nhận cả account_type.id lẫn account_type_id)
 * @param {Number|String} [areaId] - khu vực đang chọn, dùng để ghi đè profile.khuvuc_id
 * @returns {Array|null} danh sách cơ chế, hoặc null khi không áp dụng luồng mới
 */
export function getMechanismsByFacility(profile, areaId = null) {
    const facility = Number(profile?.facility);

    // Không có facility => giữ nguyên luồng cũ
    console.log(facility,'facility')
    if (!facility) {
        return null;
    }

    const accountTypeId = Number(profile?.account_type?.id ?? profile?.account_type_id);

    // Cộng tác viên dùng chung cơ chế trên toàn công ty
    if (Number(profile?.is_collaborators) === 1) {
        return facilityCollaboratorMechanism;
    }

    // Sales (SL, SE, Sale, SI) - phân biệt theo cơ sở trả lương + khu vực
    if (ACCOUNT_TYPE_SALES.includes(accountTypeId)) {
        const allowedAreaIds = facilityAreaIds[facility];
        const currentAreaId = Number(areaId ?? profile?.khuvuc_id);
        console.log(allowedAreaIds && !allowedAreaIds.includes(currentAreaId), currentAreaId, allowedAreaIds, 'rrrr')

        // Cơ chế lương tỉnh chỉ áp dụng đúng danh sách khu vực của cơ sở đó
        if (allowedAreaIds && !allowedAreaIds.includes(currentAreaId)) {
            return null;
        }

        return facilitySalesMechanism[facility] ?? null;
    }

    // GĐVP - dùng chung cho tất cả khu vực
    if (accountTypeId === ACCOUNT_TYPE_GDVP) {
        return facilityManagerMechanism;
    }

    return null;
}
